module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "user-detail"
    }
  }, [_c('v-breadcrumbs', {
    attrs: {
      "items": [{
          text: 'Dashboard',
          to: {
            path: '/'
          }
        },
        {
          text: 'User Management',
          to: {
            path: '/user-management'
          }
        },
        {
          text: 'Informasi User'
        } ],
      "divider": "|"
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "header-text font-weight-bold"
  }, [_vm._v("Informasi User")]), _vm._v(" "), _c('v-layout', {
    staticClass: "pt-0 px-0 pb-3 mb"
  }, [_c('v-btn', {
    staticClass: "mr-2",
    class: _vm.tab == 3 ? 'darkFade--text' : 'white--text',
    attrs: {
      "id": "user-detail-btn",
      "color": _vm.tab == 3 ? 'white' : 'blew',
      "elevation": "0"
    },
    on: {
      "click": function($event) {
        _vm.tab = 1
      }
    }
  }, [_vm._v("Detail")]), _vm._v(" "), _c('v-btn', {
    staticClass: "mr-2",
    class: _vm.tab == 3 ? 'white--text' : 'darkFade--text',
    attrs: {
      "id": "user-history-tryout-btn",
      "color": _vm.tab == 3 ? 'blew' : 'white',
      "elevation": "0"
    },
    on: {
      "click": function($event) {
        _vm.tab = 3
      }
    }
  }, [_vm._v("Riwayat Tryout")])], 1), _vm._v(" "), (_vm.isUpdate) ? _c('div', [_c('v-card', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tab == 1),
      expression: "tab == 1"
    }]
  }, [_c('v-card-title', [_vm._v("\n                Detail User\n                "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "blew--text",
    attrs: {
      "id": "user-update-btn",
      "elevation": "0",
      "color": "white"
    },
    on: {
      "click": _vm.updateData
    }
  }, [_c('v-icon', {
    staticStyle: {
      "font-size": "16px !important"
    }
  }, [_vm._v("mdi-pencil")]), _vm._v("\n                    Ubah Data\n                ")], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card', {
    staticClass: "d-flex pb-3",
    attrs: {
      "flat": ""
    }
  }, [_c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "3"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', [_c('v-card', {
    staticClass: "border-bottom-divider rounded-tl px-2",
    attrs: {
      "flat": ""
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('v-img', {
    attrs: {
      "aspect-ratio": "1",
      "src": _vm.$store.state.usman.picture
    }
  })], 1)])], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "px-0",
    staticStyle: {
      "border-left": "1px solid #f0f0f0"
    },
    attrs: {
      "cols": "9"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', {
    staticClass: "pa-0"
  }, [_c('v-list-item', [_c('v-list-item-title', {
    staticClass: "font-weight-bold"
  }, [_vm._v("\n                                    Nama Siswa\n                                ")]), _vm._v(" "), _c('div', [_vm._v("\n                                    " + _vm._s(_vm.$store.state.usman.name.toUpperCase()) + "\n                                ")])], 1), _vm._v(" "), _c('v-list-item', {
    staticStyle: {
      "background-color": "#fbfbfb"
    }
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold"
  }, [_vm._v("\n                                    No Siswa\n                                ")]), _vm._v(" "), _c('div', [_vm._v("\n                                    " + _vm._s(_vm.$store.state.usman.student_number) + "\n                                ")])], 1), _vm._v(" "), _c('v-list-item', [_c('v-list-item-title', {
    staticClass: "font-weight-bold"
  }, [_vm._v("\n                                    Email\n                                ")]), _vm._v(" "), _c('div', [_vm._v("\n                                    " + _vm._s(_vm.$store.state.usman.email) + "\n                                ")])], 1), _vm._v(" "), _c('v-list-item', {
    staticStyle: {
      "background-color": "#fbfbfb"
    }
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold"
  }, [_vm._v("\n                                    No.Telpon\n                                ")]), _vm._v(" "), _c('div', [_vm._v("\n                                    " + _vm._s(_vm.$store.state.usman.phone_number) + "\n                                ")])], 1), _vm._v(" "), _c('v-list-item', [_c('v-list-item-title', {
    staticClass: "font-weight-bold"
  }, [_vm._v("\n                                    Sekolah\n                                ")]), _vm._v(" "), _c('div', [_vm._v("\n                                    " + _vm._s(_vm.$store.state.usman.school ?
    _vm.$store.state.usman.school.toUpperCase() :
    "") + "\n                                ")])], 1), _vm._v(" "), _c('v-list-item', {
    staticStyle: {
      "background-color": "#fbfbfb"
    }
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold"
  }, [_vm._v("\n                                    Kelas\n                                ")]), _vm._v(" "), _c('div', [_vm._v("\n                                    " + _vm._s(_vm.$store.state.usman.grade) + "\n                                ")])], 1), _vm._v(" "), (_vm.$store.state.usman.group_schedule) ? _c('v-list-item', [_c('v-list-item-title', {
    staticClass: "font-weight-bold"
  }, [_vm._v("\n                                    Group\n                                ")]), _vm._v(" "), _c('div', [_vm._v("\n                                    " + _vm._s(_vm.data.group_schedule ?
    _vm.data.group_schedule :
    "-") + "\n                                ")])], 1) : _vm._e(), _vm._v(" "), _c('v-list-item', {
    style: (_vm.$store.state.usman.group_schedule ?
      'background-color: #fbfbfb' :
      '')
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold"
  }, [_vm._v("\n                                    Status\n                                ")]), _vm._v(" "), (_vm.isActive) ? _c('div', [_vm._v("\n                                    Aktif sampai:\n                                    " + _vm._s(_vm.$store.state.usman.expired_at) + "\n                                ")]) : _c('div', {
    staticClass: "burgundy--text font-weight-bold"
  }, [_vm._v("\n                                    Inactive\n                                ")])], 1), _vm._v(" "), (_vm.isUpdate) ? _c('v-list-item', [_c('v-list-item-title', {
    staticClass: "font-weight-bold"
  }, [_vm._v("\n                                    User Scope\n                                ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, _vm._l((_vm.detail.user_app_scopes), function(scope, index) {
    return _c('v-btn', {
      key: index,
      staticClass: "mb-2 mr-2",
      attrs: {
        "rounded": "",
        "depressed": "",
        "disabled": ""
      }
    }, [_vm._v("\n                                        " + _vm._s(scope.app_scope_id.name) + "\n                                    ")])
  }), 1)], 1) : _vm._e()], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tab == 3),
      expression: "tab == 3"
    }]
  }, _vm._l((_vm.memberships), function(membership, key) {
    return _c('v-card', {
      key: key,
      staticClass: "pa-2 mb-2",
      staticStyle: {
        "background": "#ffffff",
        "box-shadow": "0px 0px 10px rgba(51, 46, 101, 0.08)",
        "border-radius": "4px"
      }
    }, [_c('v-card-title', {
      staticClass: "text-subtitle-1 font-weight-bold darkBlue--text"
    }, [_vm._v("\n                    " + _vm._s(membership.name) + "\n                ")]), _vm._v(" "), _c('v-card-subtitle', [_vm._v("\n                    (" + _vm._s(_vm.displayTimestamp(membership.opened_at)) + " -\n                    " + _vm._s(_vm.displayTimestamp(membership.closed_at)) + ")\n                ")]), _vm._v(" "), _c('v-card-text', [_c('v-card', {
      attrs: {
        "outlined": "",
        "color": "#FBFBFB"
      }
    }, [_c('v-card-text', [_c('table', {
      staticStyle: {
        "width": "100%",
        "table-layout": "fixed"
      }
    }, [_c('thead', [_c('tr', [_c('th', {
      staticClass: "text-left"
    }, [_vm._v("\n                                            Nama Tryout\n                                        ")]), _vm._v(" "), _c('th', {
      staticClass: "text-left"
    }, [_vm._v("Status")]), _vm._v(" "), _c('th', {
      staticClass: "text-left"
    }, [_vm._v("\n                                            Pengerjaan (m)\n                                        ")]), _vm._v(" "), _c('th', {
      staticClass: "text-left"
    }, [_vm._v("Soal")]), _vm._v(" "), _c('th', {
      staticClass: "text-left"
    }, [_vm._v("Benar")]), _vm._v(" "), _c('th', {
      staticClass: "text-left"
    }, [_vm._v("Salah")]), _vm._v(" "), _c('th', {
      staticClass: "text-left"
    }, [_vm._v("Kosong")]), _vm._v(" "), _c('th', {
      staticClass: "text-left"
    })])]), _vm._v(" "), _c('tbody', _vm._l((membership.tryouts), function(tryout, key) {
      return _c('tr', {
        key: key,
        staticClass: "font-weight-700"
      }, [_c('td', {
        staticClass: "text-left"
      }, [_vm._v("\n                                            " + _vm._s(tryout.name) + "\n                                        ")]), _vm._v(" "), _c('td', {
        staticClass: "text-left"
      }, [(
        tryout.state ===
        'JOINED'
      ) ? _c('div', {
        staticClass: "tryout-state blew--text"
      }, [_vm._v("\n                                                Bergabung\n                                            ")]) : _vm._e(), _vm._v(" "), (
        tryout.state ===
        'STARTED'
      ) ? _c('div', {
        staticClass: "tryout-state warning--text"
      }, [_vm._v("\n                                                Mengerjakan\n                                                "), _c('span', [_vm._v("(" + _vm._s(_vm.displayTimestamp(
        tryout.started_at
      )) + ")")])]) : _vm._e(), _vm._v(" "), (
        tryout.state ===
        'FINISHED'
      ) ? _c('div', {
        staticClass: "tryout-state warning--text"
      }, [_vm._v("\n                                                Mengumpulkan\n                                                "), _c('span', [_vm._v("(" + _vm._s(_vm.displayTimestamp(
        tryout.completed_at
      )) + ")")])]) : _vm._e(), _vm._v(" "), (
        tryout.state ===
        'GRADED'
      ) ? _c('div', {
        staticClass: "tryout-state success--text"
      }, [_vm._v("\n                                                Dinilai\n                                            ")]) : _vm._e()]), _vm._v(" "), _c('td', {
        staticClass: "text-left"
      }, [_vm._v("\n                                            " + _vm._s(tryout.completion_time ?
        Math.ceil(
          tryout.completion_time /
          60
        ) :
        "-") + "\n                                        ")]), _vm._v(" "), _c('td', {
        staticClass: "text-left"
      }, [_vm._v("\n                                            " + _vm._s(_vm.getItemCount(tryout)) + "\n                                        ")]), _vm._v(" "), _c('td', {
        staticClass: "text-left"
      }, [_vm._v("\n                                            " + _vm._s(tryout.correct) + "\n                                        ")]), _vm._v(" "), _c('td', {
        staticClass: "text-left"
      }, [_vm._v("\n                                            " + _vm._s(tryout.wrong) + "\n                                        ")]), _vm._v(" "), _c('td', {
        staticClass: "text-left"
      }, [_vm._v("\n                                            " + _vm._s(tryout.empty) + "\n                                        ")]), _vm._v(" "), _c('th', {
        staticClass: "text-right"
      }, [_c('v-btn', {
        staticClass: "redLight--text",
        attrs: {
          "id": "user-reset-tryout-btn",
          "plain": "",
          "disabled": tryout.state ===
            'JOINED'
        },
        on: {
          "click": function($event) {
            _vm.dialogConfirm.open = true;
            _vm.dialogConfirm.bundle_code =
              tryout.bundle_code;
            _vm.dialogConfirm.email =
              _vm.$store.state.usman.email;
          }
        }
      }, [_vm._v("Reset")])], 1)])
    }), 0)])])], 1)], 1)], 1)
  }), 1)], 1) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "506px"
    },
    model: {
      value: (_vm.dialogConfirm.open),
      callback: function($$v) {
        _vm.$set(_vm.dialogConfirm, "open", $$v)
      },
      expression: "dialogConfirm.open"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "text-h5",
    staticStyle: {
      "word-break": "break-word !important"
    }
  }, [_vm._v("\n                Yakin ingin mengembalikan status ?\n            ")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n                Status pengerjaan try out ini akan menjadi Bergabung.\n            ")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "id": "user-cancel-reset-btn",
      "color": "darkFade",
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.dialogConfirm.open = false;
        _vm.dialogConfirm.bundle_code = null;
        _vm.dialogConfirm.email = null;
      }
    }
  }, [_vm._v("\n                    Batal\n                ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "id": "user-OK-btn",
      "color": "blew",
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.resetState(
          _vm.dialogConfirm.bundle_code,
          _vm.dialogConfirm.email
        );
        _vm.dialogConfirm.open = false;
      }
    }
  }, [_vm._v("\n                    OK\n                ")])], 1)], 1)], 1), _vm._v(" "), (_vm.isLoading) ? _c('app-spinner') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d48a8e3a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/usman/components/UserManagementDetail.vue
// module id = 2151
// module chunks = 1